module.exports = __webpack_public_path__ + "e71c208e7195cc8a70f7e295d7c7f56d.svg";